import Logo from '@/components/logo';

export default function OnHold() {
  return (
    <div className="w-full min-h-screen p-6 py-10 md:p-20 text-white bg-gradient-to-r from-heineken-green via-heineken-light-green to-heineken-dark-green flex flex-col items-center">
      <Logo />

      <div className="max-w-2xl mx-auto flex flex-1 flex-col items-center justify-center text-center py-16 md:py-24">
        <h1 className="font-heineken font-bold text-3xl md:text-5xl leading-tight">
          Köszönjük, hogy velünk játszottál! 🍻
        </h1>

        <div className="mt-8 md:mt-10 flex flex-col gap-6">
          <p>
            A 2026-os HEINEKEN Liga véget ért. Köszönjük, hogy idén is velünk
            tartottál, gyűjtötted a krediteket és részese voltál a Ligának!
          </p>
          <p>
            Reméljük, örömöd leled a kiválasztott ajándékodban és sokáig
            emlékeztet majd ránk.
          </p>
          <p>Most egy kis szünet következik, de hamarosan újra találkozunk.</p>
          <p>A HEINEKEN Liga csapata</p>
        </div>
      </div>
    </div>
  );
}
